/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { FormattedMessage } from 'react-intl';

import { InlineNotification, Typography2 } from '@coursera/cds-core';

import { allowedFileTypesForAiGrading, mediaMaxBytesForAiPeerReview } from 'bundles/grading-common/utils/constants';
import { useAiGradingContext } from 'bundles/peer/components/ai-grading/AiEligibilityProvider';

import _t from 'i18n!nls/peer';

export type Props = {
  filename?: string;
};

const styles = {
  marginBottom: css`
    margin-bottom: var(--cds-spacing-150);
  `,
};

const SupportedFilesForAiGradingNotification = ({ filename }: Props) => {
  const { isAiGradingFlowPreview } = useAiGradingContext();
  const isAiGradingFlow = isAiGradingFlowPreview();
  if (isAiGradingFlow && !filename) {
    return (
      <InlineNotification severity="information" css={styles.marginBottom}>
        <FormattedMessage
          message={_t(
            'The following file types can be graded by AI (up to {mediaMaxMb} MB for audio and video): {allowedFileTypeList}. If you upload another file type, your assignment will be graded by your peers instead.'
          )}
          allowedFileTypeList={
            <Typography2 component="span" variant="subtitleMedium">
              {Object.values(allowedFileTypesForAiGrading).join(', ')}
            </Typography2>
          }
          mediaMaxMb={Math.floor(mediaMaxBytesForAiPeerReview / 1000000)}
        />
      </InlineNotification>
    );
  }

  return null;
};

export default SupportedFilesForAiGradingNotification;
